export const finderFileListItemStyles = (theme) => ({
    container: {
        padding: "0 5px",
    },
    label: {
        minWidth: 0,
        flex: 1,
        margin: 0,
        marginLeft: 12,
        color: "inherit",
        cursor: "pointer",
        fontSize: 16,
        lineHeight: 1.25,
        textAlign: "left",
        overflowWrap: "break-word",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    listItem: {
        width: "100%",
        height: 60,
        margin: "5px 0",
        padding: "8px 10px",
        color: theme.palette.text.primary,
        backgroundColor:
            theme.palette.mode === "dark"
                ? theme.palette.background.subtle
                : "rgb(249, 249, 249)",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 10,
        boxSizing: "border-box",
        cursor: "pointer",
        fontFamily: "inherit",
        transition:
            "background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease, transform 150ms cubic-bezier(0.2, 0, 0, 1)",
        "& .MuiTouchRipple-rippleVisible": {
            opacity: "0.12 !important",
            animationDuration: "300ms !important",
        },
        "& .MuiAvatar-root": {
            width: 40,
            height: 40,
            flexShrink: 0,
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.action.hover,
            borderRadius: 8,
            transition: "transform 180ms cubic-bezier(0.2, 0, 0, 1)",
        },
        "&:hover": {
            backgroundColor: theme.palette.background.media,
            borderColor: theme.palette.text.disabled,
            boxShadow:
                theme.palette.mode === "dark"
                    ? "0 3px 10px rgba(0, 0, 0, 0.24)"
                    : "0 3px 10px rgba(20, 35, 25, 0.07)",
            transform: "translateY(-1px)",
            "& .MuiAvatar-root": {
                transform: "scale(1.04)",
            },
        },
        "&:active": {
            transform: "translateY(1px) scale(0.985)",
        },
        "&:focus-visible": {
            outline: "3px solid rgba(0, 149, 61, 0.28)",
            outlineOffset: 1,
        },
        "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
            "& .MuiAvatar-root": {
                transition: "none",
            },
            "&:hover, &:active": {
                transform: "none",
            },
            "&:hover .MuiAvatar-root": {
                transform: "none",
            },
            "& .MuiTouchRipple-rippleVisible": {
                animationDuration: "1ms !important",
            },
        },
    },
    dragging: {
        "&&": {
            zIndex: 5,
            transform: "scale(1.025)",
            borderColor: "rgba(0, 149, 61, 0.38)",
            backgroundColor:
                theme.palette.mode === "dark" ? "#243328" : "#f7fbf8",
            boxShadow:
                theme.palette.mode === "dark"
                    ? "0 16px 34px rgba(0, 0, 0, 0.42)"
                    : "0 16px 34px rgba(20, 35, 25, 0.2)",
        },
        "@media (prefers-reduced-motion: reduce)": {
            "&&": {
                transform: "none",
            },
        },
    },
    thumbnail: {
        width: 40,
        height: 40,
        borderRadius: 8,
    },
});

export const finderContextMenuPaperProps = {
    sx: (theme) => ({
        mt: 0.5,
        minWidth: 180,
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
        boxShadow:
            theme.palette.mode === "dark"
                ? "0 14px 36px rgba(0, 0, 0, 0.44)"
                : "0 14px 36px rgba(20, 35, 25, 0.16)",
        "& .MuiMenu-list": {
            padding: 0.75,
        },
        "& .MuiMenuItem-root": {
            minHeight: 40,
            borderRadius: 1.5,
            paddingLeft: 1.5,
            paddingRight: 1.5,
            "&:hover": {
                backgroundColor:
                    theme.palette.mode === "dark"
                        ? "rgba(31, 184, 94, 0.12)"
                        : "rgba(0, 149, 61, 0.08)",
            },
        },
    }),
};
